import Vue from 'vue'
import Router from '@/common/vueRouter'
import App from '../App.vue'
import { ROUTE_NAMES } from '../const'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      name: ROUTE_NAMES.SEARCH,
      path: '/search',
      component: App,
      props: true
    },
    {
      name: ROUTE_NAMES.CATEGORY,
      path: '/categories/:categoryName',
      component: App,
      props: true
    },
    {
      name: ROUTE_NAMES.CHILD_CATEGORY,
      path: '/categories/:categoryName/:childCategory',
      component: App,
      props: true
    },
    {
      name: ROUTE_NAMES.BRAND,
      path: '/brands/:brandName',
      component: App,
      props: true
    }
  ],
  scrollBehavior(to) {
    if (to.hash)
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    return {
      x: 0,
      y: 0,
      behavior: 'smooth'
    }
  }
})
